import { GCBErrorCode, GCBError } from '../types';

export async function handleApiError(response: Response): Promise<never> {
  const errorData = await response.json();

  if (response.status === 409) {
    throw new GCBError(
      `Conflict ${errorData.errorCode}`,
      GCBErrorCode.CONFLICT,
      409,
      errorData.error.details,
    );
  }

  if (response.status === 403) {
    if (errorData.errorCode === GCBErrorCode.INSUFFICIENT_PERMISSIONS) {
      throw new GCBError(
        errorData.error.message,
        GCBErrorCode.INSUFFICIENT_PERMISSIONS,
        403,
        errorData.error.details,
      );
    }
    throw new GCBError(
      'Forbidden',
      GCBErrorCode.FORBIDDEN,
      403,
      errorData.error.details,
    );
  }

  throw new GCBError(
    errorData.error.message || 'Unknown error',
    errorData.errorCode || GCBErrorCode.UNKNOWN_ERROR,
    response.status,
    errorData.error.details,
  );
}
